import { useEffect, useState } from "react"

export function useReferralUpdater(
  initialPage,
  initialHtmlStringData,
  location,
  settings,
) {
  const [updatedPage, setUpdatedPage] = useState(initialPage)
  const [updatedHtmlStringData, setUpdatedHtmlStringData] = useState(
    initialHtmlStringData,
  )

  useEffect(() => {
    if (!initialPage.tags.find(tag => tag.name === "#referral")) return

    const searchParams = new URLSearchParams(location.search)
    let celloN = searchParams.get("celloN") || ""
    const safeDecodeBase64 = encodedString => {
      try {
        if (!/^[A-Za-z0-9+/=]+$/.test(encodedString))
          throw new Error("Invalid Base64 format")
        let decodedString = atob(encodedString)
        if (!/^[\x20-\x7E]*$/.test(decodedString))
          throw new Error("Decoded string contains invalid characters")
        return decodedString
      } catch (error) {
        console.error("Base64 decoding failed:", error.message)
        return ""
      }
    }
    const sanitizeName = name =>
      name
        .replace(/<\/?[^>]+(>|$)/g, "")
        .replace(/[^a-zA-Z0-9а-яА-ЯёЁ\s.'-]/g, "")
        .substring(0, 50)

    if (celloN) {
      const decoded = safeDecodeBase64(celloN)
      if (decoded) celloN = sanitizeName(decoded)
    }

    let newHtmlStringData = initialHtmlStringData
    let newPage = { ...initialPage }

    if (typeof newHtmlStringData === "string" && celloN) {
      newHtmlStringData = newHtmlStringData.replace(
        /{{name}}/g,
        `<b>${celloN}</b>`,
      )
    }
    if (newPage.title && typeof newPage.title === "string" && celloN) {
      newPage.title = newPage.title.replace(
        /{{name}}/g,
        `<b class="text-purple-300">${celloN}</b>`,
      )
    }

    let excerpt = typeof newPage.excerpt === "string" ? newPage.excerpt : ""
    let originalExcerpt = newPage.originalExcerpt || excerpt
    if (
      settings.og_description &&
      !originalExcerpt.includes(settings.og_description)
    ) {
      originalExcerpt = `${originalExcerpt} ${settings.og_description}`
    }
    excerpt = originalExcerpt

    const classRegex = /{{class:\s*([^}]+)}}/
    const match = excerpt.match(classRegex)
    if (match) {
      const classes = match[1].trim()
      let descriptionSuffix = ""
      if (
        settings.og_description &&
        excerpt.endsWith(settings.og_description)
      ) {
        descriptionSuffix = settings.og_description
        excerpt = excerpt.slice(0, -settings.og_description.length).trim()
      }
      let excerptWithoutMarker = excerpt.replace(classRegex, "").trim()
      excerptWithoutMarker = celloN
        ? excerptWithoutMarker.replace(/{{name}}/g, celloN)
        : excerptWithoutMarker
      excerpt = `<div class="${classes}">${excerptWithoutMarker}</div>`
      if (descriptionSuffix) excerpt += ` ${descriptionSuffix}`
    }
    newPage.excerpt = excerpt

    setUpdatedHtmlStringData(newHtmlStringData)
    setUpdatedPage(newPage)
  }, [location, initialPage, initialHtmlStringData, settings.og_description])

  return { updatedPage, updatedHtmlStringData }
}
